import { withTracking } from '../../../observability';
import { SectionName } from '../../../observability/tracking/events';
import { createBuilderModule } from '../../../builder';
import { Sponsors } from './Sponsors';

export default createBuilderModule(
  withTracking(Sponsors, {
    sectionName: SectionName.Sponsors,
  }),
  {
    name: 'Sponsors',
    inputs: [
      { name: 'heading', type: 'string' },
      { name: 'description', type: 'string' },
      {
        name: 'logos',
        type: 'list',
        subFields: [
          { name: 'url', type: 'cloudinaryImage', required: true },
          { name: 'altText', type: 'string', required: true },
        ],
      },
    ],
  },
);
